import { lazy } from 'react';
import type { ComponentProps } from 'react';
import type { MasterDefinitionTable } from './MasterDefinitionTable';
import type { BaseMasterRecord } from '../../models/baseMaster.types';

/** The props of the definition-driven list table, for any record shape. */
export type MasterDefinitionTableProps = ComponentProps<typeof MasterDefinitionTable<BaseMasterRecord>>;

/**
 * The definition-driven list table every master screen draws, for a screen outside Masters.
 *
 * Lazy on purpose. The barrel is imported by the route table, so a static export would put the table,
 * PrimeReact's DataTable and `masterScreen.css` in the main chunk -- and that sheet carries rules that are
 * not scoped to `.ms` (`.p-hidden-accessible`, `.sr-only`), which would then apply to every screen from
 * the first paint instead of only once a list screen has loaded. Behind `lazy` they stay in their own chunk,
 * loaded by the first screen that renders the table. Render it inside a `Suspense`.
 */
/** The masters' screen stylesheet alone, for a page that draws their markup without the table. */
export const LazyMasterScreenStyles = lazy(() => import('../../components/MasterScreenStyles'));

export const LazyMasterDefinitionTable = lazy(async () => {
  const module = await import('./MasterDefinitionTable');
  return {
    default: module.MasterDefinitionTable as (props: MasterDefinitionTableProps) => ReturnType<typeof module.MasterDefinitionTable>,
  };
});
